module.exports = __webpack_public_path__ + "img/WhiteDoubleArrowLeft.f1aeb265.svg";